// Leo's inline SVG icons, as he drew them.
const base = { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': 'true' };

export const UploadIcon = ({ size = 16, color = '#2E2116' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" stroke={color} strokeWidth="2" {...base}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" x2="12" y1="3" y2="15" />
  </svg>
);
export const AskIcon = ({ size = 16, color = '#2E2116' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" stroke={color} strokeWidth="2" {...base}>
    <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" /><path d="M19 10v2a7 7 0 0 1-14 0v-2" /><line x1="12" x2="12" y1="19" y2="22" />
  </svg>
);
export const SearchIcon = ({ size = 16, color = '#2E2116' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" stroke={color} strokeWidth="2" {...base}>
    <circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" />
  </svg>
);
export const SettingsIcon = ({ size = 16, color = '#2E2116' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" stroke={color} strokeWidth="2" {...base}>
    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" /><circle cx="12" cy="12" r="3" />
  </svg>
);

const tile = { viewBox: '0 0 24 24', stroke: '#A34A1B', strokeWidth: '1.8', ...base };
export const CasesTileIcon = ({ size = 30 }) => (
  <svg {...tile} width={size} height={size}><rect x="8" y="3" width="11" height="14" rx="2" /><path d="M5 7v12a2 2 0 0 0 2 2h9" /></svg>
);
export const ReportsTileIcon = ({ size = 30 }) => (
  <svg {...tile} width={size} height={size}><path d="M4 4v16h16" /><path d="M8 16v-3M12 16v-6M16 16v-4" /><path d="M7 9c3-5 6 1 9-3" /></svg>
);
export const InventoryTileIcon = ({ size = 30 }) => (
  <svg {...tile} width={size} height={size}><path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z" /><path d="M4 7.5l8 4.5 8-4.5M12 12v9" /></svg>
);
export const BigMicIcon = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
    <rect x="9" y="3" width="6" height="12" rx="3" /><path d="M5 11a7 7 0 0 0 14 0M12 18v3" />
  </svg>
);
export const HistoryGlyph = ({ size = 30 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#2E2116" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="9" /><polyline points="12 7 12 12 15 14" />
  </svg>
);
